import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const NO_HEADER_PATHS = ['/login', '/register', '/verify-email', '/forgot-password', '/reset-password', '/onboarding/plans', '/onboarding/setup', '/onboarding/profile'];

const BaseLayout: React.FC = () => {
  const { pathname } = useLocation();
  const hideHeader =
    NO_HEADER_PATHS.includes(pathname) || pathname.startsWith('/invite/');

  return (
    <div className={hideHeader ? '' : 'min-h-svh bg-ui'}>
      {!hideHeader && (
        <header className="bg-ui-card shadow-sm h-14 flex items-center px-4 md:px-6">
          <span className="font-semibold text-brand-dark">SmartContractor</span>
        </header>
      )}
      <main className={hideHeader ? '' : 'pt-4'}>
        <Outlet />
      </main>
    </div>
  );
};

export default BaseLayout;
